import { useEffect, useState, useRef } from "react";
import { CalendarCheck, Notebook, X, FileX, File, Pencil, Settings, ShieldUser, Store, Wallet, Trash2, CheckCircle, Search } from 'lucide-react';
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import DateRangePicker from "../../components/DateRangePicker";
import FilterBar from "../../components/FilterBar";

export default function AjuanMobile() {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [showAction, setShowAction] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [success, setSuccess] = useState(false);
  const [search, setSearch] = useState("");
  const [showFilterTanggalExcel, setShowFilterTanggalExcel] = useState(false);
  const [user, setUser] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const email = storedUser?.email;
  const level = storedUser?.level;
  
  const [userInput, setUserInput] = useState(email);
  
  const [filters, setFilters] = useState({
    id_vendor: "",
    id_event: "",
    user_input: "",
    read: "",
    trf: "",
    startDate: "",
    endDate: "",
    type: []
  });

  const handleClearFilter = () => {
    setFilters({
      id_vendor: "",
      id_event: "",
      user_input: "",
      read: "",
      trf: ""
    });

    setPage(1);
    setData([]);
  };

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const email = storedUser?.email;

    fetch(`${process.env.REACT_APP_BASE_URL}api/users/search?email=${encodeURIComponent(email)}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setUser(data.data);
          console.error(data.data);
        } else {
          console.error(data.message);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    if (user?.email) {
      fetchData(true);
    }
  }, [user]);

  const fetchData = async (reset = false) => {
    const user_input = user?.group_id === "3" ? user?.email : "";
    const res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/ajuan?page=${page}&user_input=${user_input}`);
    const result = await res.json();

    setData((prev) => (reset ? result.data : [...prev, ...result.data]));
  };

  useEffect(() => {
    fetchData();
  }, [page,userInput]);

  // infinite scroll
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 200
      ) {
        setPage((prev) => prev + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleTrf = async (id) => {
    // Ambil data dulu
    const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${id}`);
    const result = await res.json();
    const note = result.data?.note || result.data?.notes || "Ajuan tidak diketahui";
    const trfValue = parseInt(result.data?.trf ?? 0);
    const trfStatus = trfValue === 1 ? 0 : 1; 

    Swal.fire({
      title: `Ubah Status Transfer?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3c30e9ff',
      cancelButtonColor: '#e9303fff',
      confirmButtonText: 'Ya, sudah',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        const now = new Date();
        const offset = 7 * 60; // +7 jam dalam menit
        const localTime = new Date(now.getTime() + offset * 60000);
        const formattedNow = localTime.toISOString().slice(0, 19).replace("T", " ");
        const today = new Date().toISOString().split("T")[0]; 
        fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ trf: trfStatus, trf_by:email, date_of_trf:formattedNow  }),
        })
          .then((res) => res.json())
          .then(() => {
            setSuccess(`Ajuan ${note} sudah dirubah status transfernya`);
            setTimeout(() => setSuccess(false), 30000);
            setPage(1);
            fetchData(true);
          });
      }
    });
  };

  const handleDelete = async (id) => {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${id}`);
      const result = await res.json();
      const note = result.data?.note || "User tidak diketahui";
      
      Swal.fire({
        title: `Yakin hapus ini?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Ya, hapus',
        cancelButtonText: 'Batal',
      }).then((result) => {
        if (result.isConfirmed) {
          fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${id}`, {
            method: 'DELETE',
          })
            .then((res) => res.json())
            .then(() => {
              Swal.fire({
                toast: true,
                position: 'top',
                icon: 'success',
                title: 'Terhapus',
                text: `Ajuan berhasil dihapus`,
                showConfirmButton: false,
                showCloseButton: true, 
              });            
              setPage(1);
              fetchData(true);
            });
        }
      });
    };
  const isEmpty = Object.values(filters).every(v => !v);
  
  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleSubmitExport = (e) => {
    e.preventDefault();
    if (!startDate || !endDate) {
      alert("Pilih tanggal terlebih dahulu!");
      return;
    }
    const formattedStart = formatDate(startDate);
    const formattedEnd = formatDate(endDate);

    if (!user.email || !user.level) {
        console.error("User tidak ditemukan di localStorage");
        return;
      }

    if (user.level === "admin" || user.level === "finance") {
      window.location.href = `${process.env.REACT_APP_BASE_URL}export/filteredRf?start=${formattedStart}&end=${formattedEnd}`;
    } else {
      window.location.href = `${process.env.REACT_APP_BASE_URL}export/export?start=${formattedStart}&end=${formattedEnd}&user_input=${encodeURIComponent(user.email)}`;
    }
  };

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const email = storedUser?.email;

    fetch(`${process.env.REACT_APP_BASE_URL}api/users/search?email=${encodeURIComponent(email)}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setUser(data.data);
          console.error(data.data);
        } else {
          console.error(data.message);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <div className="space-y-4 min-h-screen">
      {success && (
        <div className="mt-2 mb-4 bg-green-100 text-green-800 p-4 rounded shadow transition-all duration-30000 flex justify-between">
          <div className="">
            <h1 className="text-md font-bold"> Berhasil</h1>
            {success}
          </div>
          <button
            onClick={() => setSuccess(null)}
            className="ml-auto text-green-600 hover:text-green-800 transition"
          >
            <X size={16} />
          </button>
        </div>
      )}
      {/* MOBILE */}
      <div className="md:hidden grid grid-cols-2 items-center gap-4">
        {/* Quick Actions */}
        <div className="flex gap-2">

          <button
            onClick={() => setShowFilterTanggalExcel(true)}
            className="
              p-4
              flex
              justify-center
              items-center
              rounded-full
              bg-green-500
              text-white
              shadow-md
            "
          >
            <FileX size={18} />
          </button>


          {(["1", "2", "3"].includes(user?.group_id ?? "")) && (
            <Link
              to="/create"
              className="
                
                md:hidden
                fixed
                bottom-20
                right-4
                z-50
                p-6

                rounded-full
                bg-gradient-to-br
                from-purple-500
                to-pink-500

                flex
                flex-col
                items-center
                justify-center

                text-white
                shadow-xl

                active:scale-95
                transition-all
              "
            >
              <File size={32} /> 
            </Link>
          )}
        </div>
{/* 
        <div className="flex relative items-center">
          <Search
            size={18}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
          />

          <input
            type="text"
            placeholder="Cari ajuan..."
            className="
              w-full
              pl-10
              pr-4
              py-3
              rounded-2xl
              border
              border-slate-200
              bg-white
              shadow-sm
            "
            onChange={(e) => setSearch(e.target.value)}
          />
        </div> */}

      </div>
      {data.map((item, index) => (
        <div
          key={index}
          className={`
            relative overflow-hidden
            rounded-3xl
            border border-white/30
            backdrop-blur-xl
            shadow-lg
            p-5
            transition-all duration-300
            active:scale-[0.98]
            hover:shadow-xl
            ${
              item.read === "read"
                ? "bg-white/60"
                : "bg-gradient-to-br from-gray-100/90 to-gray-500/90"
            }
          `}
        >
          {/* Glow Effect */}
          <div className="absolute -top-10 -right-10 w-24 h-24 bg-gray-300/20 rounded-full blur-3xl"></div>
          

          {/* Header */}
          <div className="grid grid-cols-2 justify-between items-start gap-3 relative z-10">
            <h2
              className={`flex flex-row gap-2 items-center
                text-[18px] leading-snug text-slate-800
                ${item.read !== "read" ? "font-semibold" : "font-medium"}
              `}
            >
              <div
                className="line-clamp-2"
                dangerouslySetInnerHTML={{ __html: item.note }}
              />
            </h2>
            <div className="flex flex-row justify-between">
              <div></div>
              <div
                className={`
                  flex items-center gap-1.5
                  px-3 py-1
                  rounded-full
                  text-[11px]
                  font-medium
                  ${
                    item.trf === "1"
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-700"
                  }
                `}
              >
                <span
                  className={`
                    w-2 h-2 rounded-full
                    ${
                      item.trf === "1"
                        ? "bg-green-500"
                        : "bg-red-500 animate-pulse"
                    }
                  `}
                />
                {
                  item.trf === "1"
                    ? "Sudah Transfer"
                    : "Belum Transfer"
                }
              </div>

            </div>
          </div>

          {/* Amount */}
          <div className="grid grid-cols-2 gap-2">
            <div className="mt-5 relative z-10">
              <div className="flex items-center gap-1">
                <Wallet className="w-3 h-3 text-gray-600" />
                <p className="text-md font-bold text-slate-900">
                  {new Intl.NumberFormat('id-ID', {
                    style: 'currency',
                    currency: 'IDR',
                    minimumFractionDigits: 0,
                  }).format(item.total)}
                </p>
              </div>
              <p className="text-slate-500 mt-1">
                {format(new Date(item.tanggal_final), "dd MMM yyyy")}
                <br />
                {format(new Date(item.tanggal_final), "HH:mm:ss")}
              </p>
            </div>
            <div className="mt-5 relative">
              <div className="flex items-center gap-2">
                <CalendarCheck className="w-3 h-3 text-gray-600" />
                <p className="text-md font-bold text-slate-900">
                  <div
                    className="line-clamp-1"
                    dangerouslySetInnerHTML={{ __html: item.event }}
                  />
                </p>
              </div>
              <div className="flex items-center gap-2">
                <Store className="w-3 h-3 text-gray-600" />
                <p className="text-md font-bold text-slate-900">
                  <div
                    className="line-clamp-1"
                    dangerouslySetInnerHTML={{ __html: item.vendor }}
                  />
                </p>
              </div>
              <div className="flex items-center gap-2">
                <ShieldUser className="w-3 h-3 text-gray-600" />
                <p className="text-md font-bold text-slate-900">
                  <div
                    className="line-clamp-1"
                    dangerouslySetInnerHTML={{ __html: item.pic }}
                  />
                </p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-5 flex justify-end relative z-10">
            <button
            onClick={() => {
              setSelectedId(item.id);
              setShowAction(true);
            }}
              className="
                flex flex-row gap-1 items-center
                px-4 py-2
                rounded-full
                text-lg font-medium
                bg-slate-900
                text-white
                hover:bg-black
                transition-all
              "
            >
              <Settings className="w-4"></Settings> Aksi
            </button>
          </div>
        </div>
      ))}

      {showAction && (
      <>
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40"
          onClick={() => setShowAction(false)}
        />

        {/* Modal */}
        <div
          className="
            fixed left-1/2 top-1/2
            -translate-x-1/2 -translate-y-1/2
            w-[90%] max-w-sm
            bg-white/80
            backdrop-blur-xl
            rounded-3xl
            shadow-2xl
            border border-white/50
            z-50
            overflow-hidden
          "
        >
          <div className="p-5">
            <h3 className="text-lg font-semibold text-slate-800 mb-4">
              Pilih
            </h3>

            <div className="space-y-2">
              {/* Edit */}
              <Link
                to={`/detail/${selectedId}`}
                className="
                  flex items-center gap-3
                  w-full
                  px-4 py-3
                  rounded-2xl
                  hover:bg-slate-100
                  transition
                "
              >
                <Search className="w-5 h-5 text-blue-600" />
                <span>Lihat Ajuan</span>
              </Link>
              {(["1", "2"].includes(user?.group_id ?? "")) && (
                <Link
                  to={`/updateRf/${selectedId}`}
                  className="
                    flex items-center gap-3
                    w-full
                    px-4 py-3
                    rounded-2xl
                    hover:bg-slate-100
                    transition
                  "
                >
                  <Pencil className="w-5 h-5 text-blue-600" />
                  <span>Edit Ajuan</span>
                </Link>
              )}
              {(["1","2"].includes(user?.group_id ?? "")) && (
                <button
                  onClick={() => {
                    handleTrf(selectedId);
                    setShowAction(false);
                  }}
                  className="
                    flex items-center gap-3
                    w-full
                    px-4 py-3
                    rounded-2xl
                    hover:bg-slate-100
                    transition
                  "
                >
                  <CheckCircle className="w-5 h-5 text-green-600" />
                  <span>Ubah Status Transfer</span>
                </button>
              )}
              {(["1","2"].includes(user?.group_id ?? "")) && (
                <button
                  onClick={() => {
                    handleDelete(selectedId);
                    setShowAction(false);
                  }}
                  className="
                    flex items-center gap-3
                    w-full
                    px-4 py-3
                    rounded-2xl
                    text-red-600
                    hover:bg-red-50
                    transition
                  "
                >
                  <Trash2 className="w-5 h-5" />
                  <span>Hapus Data</span>
                </button>
              )}
            </div>

            <button
              onClick={() => setShowAction(false)}
              className="
                mt-4
                w-full
                py-3
                rounded-2xl
                bg-slate-500
                hover:bg-slate-700
                transition
                text-white
              "
            >
              Batal
            </button>
          </div>
        </div>
      </>
    )}
    {showFilterTanggalExcel && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <form className="space-y-4">
          <div className="bg-white p-6 rounded-2xl shadow-2xl max-w-md w-full">
            <h3 className="text-lg font-bold mb-4">Filter Tanggal Export ke Excel</h3>
            {/* Komponen DateRange */}
            <DateRangePicker
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
            />

            <div className="flex justify-end gap-2 mt-6">
              <button
                onClick={() => setShowFilterTanggalExcel(false)}
                className="bg-gradient-to-br from-gray-300 to-slate-950 text-white px-4 py-2 rounded-2xl hover:scale-110 transition"
              >
                Batal
              </button>
              <button
                onClick={handleSubmitExport}
                className="bg-gradient-to-br from-cyan-500 to-blue-800 text-white px-4 py-2 rounded-2xl hover:scale-110 transition"
              >
                Terapkan
              </button>
            </div>
          </div>
          </form>
      </div>
    )}
    </div>
  );
}